
import { Box, FormControlLabel, Typography, styled } from '@mui/material';
import { FC, ReactElement } from 'react';

import { IFormField, IFormFieldRow, IFormFieldTitle, TitlePosition } from '../../../../api/dtos/dtos';
import MuiMarkdown from 'mui-markdown';


/* -- Styled Components -- */
const StyledControlLabel = styled(FormControlLabel)(() => ({
    margin: '0',
    padding: '0'
}));


export interface ITextFieldControlLabelProps {
    field: IFormField & IFormFieldTitle & IFormFieldRow;
    control: ReactElement<any, any>
}

/* -- Default Component -- */
const TextFieldControlLabel: FC<ITextFieldControlLabelProps> = ({
    field,
    control
}) => {

    const getTitle = (title?: string) => {
        if (title?.endsWith('*')) {
            const blackLabel = title.slice(0, -1);
            const redLabel = '*';
    
            return (
                <>
                    <MuiMarkdown>{blackLabel + " "}</MuiMarkdown>
                    <Box component="span" sx={{ color: 'red' }}>{redLabel}</Box>
                </>
            );
        }
    
        return (
                <MuiMarkdown>{title}</MuiMarkdown>
        );
    };

    return (
        field.titlePos === TitlePosition.Left || 
        field.titlePos === TitlePosition.Right || 
        field.titlePos === TitlePosition.Top ?
            <StyledControlLabel
                sx={{
                    width: '100%',
                }}
                labelPlacement={
                    field.titlePos === TitlePosition.Left ? 'start' : 
                    field.titlePos === TitlePosition.Right ? 'end' :
                    'top'
                }
                label={
                    <Box width={field.titleWidth ? `${field.titleWidth}px` : 'default'}>
                        <Typography 
                            sx={{ 
                                margin: '0', 
                                textWrap: 'nowrap', 
                                textAlign: field.titlePos === TitlePosition.Right ? 'end' : 'start',
                                marginRight: !field.titleWidth && field.titlePos === TitlePosition.Left ? '5px' : '0px',
                                marginLeft: !field.titleWidth && field.titlePos === TitlePosition.Right ? '5px' : '0px'
                            }}
                        >
                            {getTitle(field.title)}
                        </Typography>
                    </Box>
                } 
                control={control}
            /> :
        field.titlePos === TitlePosition.TopLeft || 
        field.titlePos === TitlePosition.TopRight || 
        field.titlePos === undefined ?
            <StyledControlLabel
                sx={{
                    width: '100%'
                }}
                labelPlacement='top'
                label={
                    <Typography 
                        sx={{ 
                            margin: '0', 
                            textWrap: 'nowrap', 
                            textAlign: field.titlePos === TitlePosition.TopRight ? 'end' : 'start',
                            width: '100%' 
                        }}
                    >
                        {getTitle(field.title)}
                    </Typography>
                } 
                control={control} 
            /> :

            control
    );
}

export default TextFieldControlLabel